import { render, staticRenderFns } from "./add-patients-screen-two.vue?vue&type=template&id=49c633d2&"
import script from "./add-patients-screen-two.vue?vue&type=script&lang=js&"
export * from "./add-patients-screen-two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports